import { NextSeo } from 'next-seo';
import { Fragment } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Splitter from '../components/Splitter';
import ContactsMap from '../components/contacts/ContactsMap';
import ContactsOffices from '../components/contacts/ContactsOffices';

const ContactsPage = () => {
  return (
    <Fragment>
      <NextSeo
        title="Контакты агентства недвижимости «ЛЕНДЛОРД»"
        description="Контактная информация агентства недвижимости «ЛЕНДЛОРД» в Ростовской области: офисы, адрес, телефон, время работы, посмотреть на карте."
        openGraph={{
          url: 'https://landlord.ru',
          type: 'website',
          title: 'Контакты агентства недвижимости «ЛЕНДЛОРД»',
          description:
            'Контактная информация агентства недвижимости «ЛЕНДЛОРД» в Ростовской области: офисы, адрес, телефон, время работы, посмотреть на карте.',
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: 'LANDLORD'
        }}
      />
      <Header />
      <main>
        <ContactsMap />
        <ContactsOffices />
        <Splitter
          title="Остались вопросы?"
          subtitle="Укажите свой номер телефона и мы обязательно ответим на них"
        />
      </main>
      <Footer seo="Контакты агентства недвижимости «ЛЕНДЛОРД»" />
    </Fragment>
  );
};

export default ContactsPage;
